"use strict";

exports.__esModule = true;
exports.default = void 0;

var _eventStack = require("@semantic-ui-react/event-stack");

var _default = _eventStack.instance;
exports.default = _default;